import styled from 'styled-components'

export const TableLoader = styled.div`
	margin-top: 0.75em;
`
TableLoader.displayName = 'TableLoader'
